// ===================================================================
// KAIXO - ChannelPickerModal
// ===================================================================
// Modal para que el usuario elija uno de SUS canales y lo comparta
// como invitación a seguir Latidos en un chat (1:1 o grupo). Mismo
// patrón visual que ContactPickerModal — estética KAIXO.
// ===================================================================

import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Icons } from '../Icons/Icons';
import useModalClose from '../../hooks/useModalClose';
import { v2GetUserChannels } from '../../services/api';
import './ChannelPickerModal.css';

export default function ChannelPickerModal({
    currentUser,
    onSelect,
    onClose
}) {
    useModalClose(onClose);
    const [channels, setChannels] = useState([]);
    const [loading, setLoading]   = useState(true);
    const [search, setSearch]     = useState('');
    const [error, setError]       = useState('');

    useEffect(() => {
        if (!currentUser?._id) return;
        let cancelled = false;
        (async () => {
            try {
                const res = await v2GetUserChannels(currentUser._id);
                if (cancelled) return;
                const list = res?.data?.channels || res?.data?.data || [];
                setChannels(Array.isArray(list) ? list : []);
            } catch (err) {
                if (!cancelled) setError('No se pudieron cargar tus canales');
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [currentUser?._id]);

    const filtered = useMemo(() => {
        const q = search.trim().toLowerCase();
        return channels
            .filter(c => !q
                || (c.name || '').toLowerCase().includes(q)
                || (c.handle || '').toLowerCase().includes(q));
    }, [channels, search]);

    return ReactDOM.createPortal(
        <div className="cpicker-overlay" onClick={onClose}>
            <div className="cpicker-modal cpicker-channel" onClick={e => e.stopPropagation()}>
                <div className="cpicker-header">
                    <h3>Compartir Latido</h3>
                    <button className="cpicker-close" onClick={onClose} aria-label="Cerrar">
                        <Icons.Close size={16} color="white" />
                    </button>
                </div>

                {channels.length > 0 && (
                    <div className="cpicker-search-wrap">
                        <input
                            className="cpicker-search"
                            type="text"
                            placeholder="Buscar canal..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            autoFocus
                        />
                    </div>
                )}

                <div className="cpicker-list">
                    {loading ? (
                        <div className="cpicker-empty">Cargando tus canales…</div>
                    ) : error ? (
                        <div className="cpicker-empty cpicker-error">{error}</div>
                    ) : channels.length === 0 ? (
                        <div className="cpicker-empty">
                            Aún no tienes canales propios para compartir.<br/>
                            <small>Crea uno en la sección Latidos.</small>
                        </div>
                    ) : filtered.length === 0 ? (
                        <div className="cpicker-empty">Sin resultados</div>
                    ) : filtered.map(c => (
                        <button
                            key={c._id}
                            className="cpicker-item"
                            onClick={() => onSelect({
                                channelId: c._id,
                                name: c.name || '',
                                handle: c.handle || '',
                                avatar: c.avatar || '',
                                coverPhoto: c.coverPhoto || ''
                            })}
                        >
                            <div className="cpicker-avatar">
                                {c.avatar
                                    ? <img src={c.avatar} alt="" />
                                    : <span>{(c.name || '?').charAt(0).toUpperCase()}</span>}
                            </div>
                            <div className="cpicker-info">
                                <div className="cpicker-name">{c.name || '(sin nombre)'}</div>
                                {c.handle && <div className="cpicker-sub">@{c.handle}</div>}
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>,
        document.body
    );
}
